import React, { Component, PropTypes } from 'react';
import ErrorField from '../ErrorField';
import Check from '../../icons/Check';
import './InputField.css';


class InputField extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
		this.getInputStyles = this.getInputStyles.bind(this);
  }

  handleChange(event) {
    const { position, field, handleChange, parentName } = this.props;
    if (position !== null) handleChange(event.target.value, field.name, position, parentName);
    else handleChange(event.target.value, field.name);
  }

  handleFocus() {
    const { position, field, handleFocus, parentName } = this.props;
    if (position !== null) handleFocus(field.name, position, parentName);
    else handleFocus(field.name);
  }

  handleBlur() {
    const { position, field, handleBlur, parentName } = this.props;
    if (position !== null) handleBlur(field.name, position, parentName);
    else handleBlur(field.name);
  }

	getInputStyles() {
    const { field } = this.props;
		let placeholderStyle = 'input__placeholder ';
		let inputStyle = 'input-field ';
    let inputWrap = 'input-field-wrap ';
    if (field.isHalf) {
      inputWrap = inputWrap + 'input-field__half ';
    }
    if (field.isHalf && field.pullRight) {
      inputWrap = inputWrap + 'input-field__right ';
    }
		if (field.touched === true) {
			placeholderStyle = placeholderStyle + 'input__touched ';
		}
		if (field.error && field.hasBlurred) {
			placeholderStyle = placeholderStyle + 'input__placeholder-error';
			inputStyle = inputStyle + 'input__border-error';
		} else if (!field.error && field.touched) {
			placeholderStyle = placeholderStyle + 'input__placeholder-success';
			inputStyle = inputStyle + 'input__border-success';
		}
		return { placeholderStyle, inputStyle, inputWrap };
	}

  render() {
    const { field } = this.props;
		let fieldStyle = this.getInputStyles();
    return (
      <div>
        {
          field.breed === 'textarea' &&
          <div className="area-field-wrap">
            <textarea
              onChange={this.handleChange}
              value={field.value}
              onBlur={this.handleBlur}
							onFocus={this.handleFocus}
              className={`area-field ${fieldStyle.inputStyle}`} />
						<p className={fieldStyle.placeholderStyle}>
							{field.placeholder}
						</p>
						{
							field.charLimit && field.value &&
							<p className="area-field__count">
								Character Count: {field.value.length}
							</p>
						}
            {
              field.error && field.hasBlurred &&
              <p className="input-field__error">{field.error}</p>
            }
          </div>
        }
        {
          field.breed === 'input' && (field.hidden === false || field.hidden === undefined) &&
          <div className={`${fieldStyle.inputWrap}`}>
            <input
              value={field.value}
              type={field.inputType}
							onFocus={this.handleFocus}
              onBlur={this.handleBlur}
              onChange={this.handleChange}
              className={`input-field ${fieldStyle.inputStyle}`} />
						<p className={fieldStyle.placeholderStyle}>
							{field.placeholder}
						</p>
            <ErrorField
              multiError={field.multiError}
              hasBlurred={field.hasBlurred}
              error={field.error}/>
          </div>
        }
      </div>
    );
  }
}

InputField.propTypes = {
  field: PropTypes.shape({
      value: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
      ]),
      placeholder: PropTypes.string.isRequired,
      hasBlurred: PropTypes.bool.isRequired,
      inputType: PropTypes.string.isRequired,
      breed: PropTypes.string.isRequired
    }),
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleFocus: PropTypes.func.isRequired
};

export default InputField;



/** WEBPACK FOOTER **
 ** ./src/components/InputField/index.js
 **/